module.exports = __webpack_public_path__ + "static/media/2 necktattoo calligraphy art pattern.1280x1707.4bbbee22.webp";